var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("edit-style")) + " "),
          _c("w-spacer"),
          _vm.showExtraActions
            ? _c(
                "w-dropdown",
                {
                  attrs: {
                    right: "",
                    white: "",
                    "use-link": "",
                    items: _vm.extraActions,
                  },
                  on: {
                    click: function ($event) {
                      return $event(_vm.toEditStyle)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        [
          _c("w-card-content", [
            _c("div", { style: _vm.toEditStyle.getStyle() }, [
              _vm._v(" " + _vm._s(_vm.previewText || _vm.$ct("preview")) + " "),
            ]),
          ]),
          _c("div", { staticClass: "seperator" }),
          _c("w-tabs", {
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
          _c(
            "w-card-content",
            [
              _vm.tab == 0
                ? _c(
                    "div",
                    [
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "cf",
                          attrs: { label: _vm.$ct("alignment") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleTitle",
                              style: { wordSpacing: "1px" },
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [_vm._v(" " + _vm._s(_vm.allignedText.text) + " ")]
                          ),
                          _c(
                            "w-row",
                            { style: { marginBottom: "10px" } },
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "3", xs: "12" } },
                                [
                                  _c("w-select", {
                                    attrs: {
                                      items: _vm.textAlignItems,
                                      label: _vm.$ct("alignment"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.TextAlign,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "TextAlign",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.TextAlign",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "3", xs: "12" } },
                                [
                                  _c("w-select", {
                                    attrs: {
                                      items: _vm.whiteSpaceItems,
                                      label: _vm.$ct("white-space"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.WhiteSpace,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "WhiteSpace",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.WhiteSpace",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.fontDisabled
                        ? _c(
                            "w-toggle-group",
                            {
                              staticClass: "cf",
                              attrs: { label: _vm.$ct("font") },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "styleTitle",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.toEditStyle.Font || "Default"
                                      ) +
                                      " > " +
                                      _vm._s(_vm.toEditStyle.FontSize) +
                                      "pt "
                                  ),
                                ]
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { md: "6", xs: "12" } },
                                    [
                                      _c("w-input-autocomplete", {
                                        attrs: {
                                          value: _vm.fontInput,
                                          items: _vm.shownFonts,
                                          label: _vm.$ct("font"),
                                          fancy: "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.fontInput = $event
                                          },
                                          focus: function ($event) {
                                            _vm.fontFocused = true
                                          },
                                          blur: function ($event) {
                                            _vm.fontFocused = false
                                          },
                                          "item-click": function ($event) {
                                            return _vm.onFontInput($event)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { md: "6", xs: "12" } },
                                    [
                                      _c("w-input-number", {
                                        attrs: {
                                          "calculate-decimals": 0,
                                          decimals: 0,
                                          label: _vm.$ct("fontSize"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.toEditStyle.FontSize,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditStyle,
                                              "FontSize",
                                              $$v
                                            )
                                          },
                                          expression: "toEditStyle.FontSize",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { md: "3", xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: { label: _vm.$ct("bold") },
                                        model: {
                                          value: _vm.toEditStyle.Bold,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditStyle,
                                              "Bold",
                                              $$v
                                            )
                                          },
                                          expression: "toEditStyle.Bold",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { md: "3", xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: { label: _vm.$ct("italic") },
                                        model: {
                                          value: _vm.toEditStyle.Italic,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditStyle,
                                              "Italic",
                                              $$v
                                            )
                                          },
                                          expression: "toEditStyle.Italic",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { md: "3", xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: { label: _vm.$ct("underline") },
                                        model: {
                                          value: _vm.toEditStyle.Underline,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditStyle,
                                              "Underline",
                                              $$v
                                            )
                                          },
                                          expression: "toEditStyle.Underline",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { md: "3", xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          label: _vm.$ct("line-through"),
                                        },
                                        model: {
                                          value: _vm.toEditStyle.LineThrough,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditStyle,
                                              "LineThrough",
                                              $$v
                                            )
                                          },
                                          expression: "toEditStyle.LineThrough",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "cf",
                          attrs: { label: _vm.$ct("transform") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleTitle",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.transformedText?.text) + " "
                              ),
                            ]
                          ),
                          _c("w-select", {
                            attrs: {
                              items: _vm.textTransformItems,
                              label: _vm.$ct("transform"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.toEditStyle.TextTransform,
                              callback: function ($$v) {
                                _vm.$set(_vm.toEditStyle, "TextTransform", $$v)
                              },
                              expression: "toEditStyle.TextTransform",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "last cf",
                          attrs: { label: _vm.$ct("colors") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleColor styleTitle",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _c(
                                "div",
                                {
                                  style: {
                                    backgroundColor:
                                      _vm.toEditStyle.BackgroundColor || "#fff",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$ct("backgroundColor")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    color: _vm.toEditStyle.Color || "#000",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("textColor")) + " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("app-color-picker", {
                                    attrs: {
                                      color: _vm.toEditStyle.BackgroundColor,
                                      label: _vm.$ct("backgroundColor"),
                                      fancy: "",
                                      up: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.BackgroundColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "BackgroundColor",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.BackgroundColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("app-color-picker", {
                                    attrs: {
                                      color: _vm.toEditStyle.Color,
                                      label: _vm.$ct("textColor"),
                                      fancy: "",
                                      up: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.Color,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.toEditStyle, "Color", $$v)
                                      },
                                      expression: "toEditStyle.Color",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.tab == 1
                ? _c(
                    "div",
                    [
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "cf",
                          attrs: { label: _vm.$ct("margins") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleTitle",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.toEditStyle.MarginTop || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.MarginRight || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.MarginBottom || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.MarginLeft || 0) +
                                  "mm "
                              ),
                            ]
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 2,
                                      decimals: 2,
                                      label: _vm.$ct("margin.top"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.MarginTop,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "MarginTop",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.MarginTop",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 2,
                                      decimals: 2,
                                      label: _vm.$ct("margin.right"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.MarginRight,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "MarginRight",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.MarginRight",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 2,
                                      decimals: 2,
                                      label: _vm.$ct("margin.bottom"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.MarginBottom,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "MarginBottom",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.MarginBottom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 2,
                                      decimals: 2,
                                      label: _vm.$ct("margin.left"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.MarginLeft,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "MarginLeft",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.MarginLeft",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-toggle-group",
                        {
                          staticClass: "cf",
                          attrs: { label: _vm.$ct("paddings") },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "styleTitle",
                              attrs: { slot: "title" },
                              slot: "title",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.toEditStyle.PaddingTop || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.PaddingRight || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.PaddingBottom || 0) +
                                  "mm " +
                                  _vm._s(_vm.toEditStyle.PaddingLeft || 0) +
                                  "mm "
                              ),
                            ]
                          ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 2,
                                      decimals: 2,
                                      label: _vm.$ct("padding.top"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.PaddingTop,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "PaddingTop",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.PaddingTop",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 2,
                                      decimals: 2,
                                      label: _vm.$ct("padding.right"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.PaddingRight,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "PaddingRight",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.PaddingRight",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 2,
                                      decimals: 2,
                                      label: _vm.$ct("padding.bottom"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.PaddingBottom,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "PaddingBottom",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.PaddingBottom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { md: "6", xs: "12" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      "calculate-decimals": 2,
                                      decimals: 2,
                                      label: _vm.$ct("padding.left"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.toEditStyle.PaddingLeft,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.toEditStyle,
                                          "PaddingLeft",
                                          $$v
                                        )
                                      },
                                      expression: "toEditStyle.PaddingLeft",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.lineHeightEnabled
                        ? _c(
                            "w-toggle-group",
                            {
                              staticClass: "cf",
                              attrs: { label: _vm.$ct("line-height") },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "styleTitle",
                                  attrs: { slot: "title" },
                                  slot: "title",
                                },
                                [
                                  _vm.toEditStyle.LineHeight === null
                                    ? [_vm._v(_vm._s(_vm.$ct("not-specified")))]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            _vm.toEditStyle.LineHeight + "mm"
                                          )
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-input-number", {
                                        attrs: {
                                          disabled:
                                            _vm.toEditStyle.LineHeight === null,
                                          label: _vm.$ct("line-height"),
                                          fancy: "",
                                        },
                                        model: {
                                          value: _vm.toEditStyle.LineHeight,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.toEditStyle,
                                              "LineHeight",
                                              $$v
                                            )
                                          },
                                          expression: "toEditStyle.LineHeight",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          value:
                                            _vm.toEditStyle.LineHeight !== null,
                                          label: _vm.$ct("line-height-enabled"),
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.setLineHeightEnabled(
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.tab == 2
                ? _c(
                    "div",
                    [
                      _c("app-style-editor-border", {
                        staticClass: "w-toggle-group last cf",
                        attrs: { "to-edit-style": _vm.toEditStyle },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("w-row"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.closeClicked()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.updateValue()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }